
    // This script helps with base URL resolution
    window.__BASE_URL__ = document.querySelector('base')?.getAttribute('href') || '/';
    window.__API_URL__ = 'https://api.carryngo.ng';
    console.log('🌐 Environment:', import.meta.env.MODE);
    console.log('🔗 API URL:', window.__API_URL__);
  